module.exports = __webpack_public_path__ + "static/media/Dashboard.1c41fa5c.svg";